module.exports = __webpack_public_path__ + "img/squiggle-random.d90afe3e.svg";